import { GlobalAxios } from "../axios/axios-config";
import { IProcedureArea } from "../models/procedure-area";

const PROCEDURE_AREA_ROUTE = process.env.REACT_APP_EXTERNAL + "/api/v1/ProcedureArea";

export const procedureAreaList = (params?: any) => {
  return GlobalAxios.get<IProcedureArea[]>(PROCEDURE_AREA_ROUTE, {
    params,
  });
};
